import { useEffect } from 'react';
import { useShopContext } from '../../context/ShopContext';

export default function ManagersTab() {
  const { managers, fetchManagers, loading, error } = useShopContext();

  useEffect(() => {
    fetchManagers();
  }, []);

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold">Managers</h2>
        {/* <button className="bg-primary text-white px-4 py-2 rounded hover:bg-primary-dark">
          Add Manager
        </button> */}
      </div>
      {loading && <p>Loading managers...</p>}
      {error && <p className="text-red-600">{error}</p>}
      {!loading && !error && managers.length === 0 && <p>No managers available.</p>}
      {!loading && !error && managers.length > 0 && (
        <div className="border rounded-lg overflow-hidden">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">branch</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Role</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {managers.map((manager) => (
                <tr key={manager.id}>
                  <td className="px-6 py-4 whitespace-nowrap">{manager.user.email ||'N/A'}</td>
                  <td className="px-6 py-4 whitespace-nowrap">{manager.user.username || 'N/A'}</td>
                  <td className="px-6 py-4 whitespace-nowrap">{manager.branch.name }</td>
                  <td className="px-6 py-4 whitespace-nowrap">{manager.role || 'Manager'}</td>
                  <td className="px-6 py-4 whitespace-nowrap space-x-2">
                    <button className="text-blue-600 hover:text-blue-800">Edit</button>
                    <button className="text-red-600 hover:text-red-800">Remove</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}